// extracted by mini-css-extract-plugin
export default {"header":"Header_header__1ny2v","main-image":"Header_main-image__4RCB9","notification":"Header_notification__7MTz-"};